import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import * as moment from 'moment/moment';
import { CalendarModule } from 'primeng/calendar';

@Component({
  standalone: true,
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    BsDatepickerModule,
    CalendarModule,
    ReactiveFormsModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true,
    },
  ],
})
export class DatePickerComponent
  implements OnInit, OnChanges, AfterViewInit, ControlValueAccessor
{
  ngControl: NgControl;
  startDate: Date | null = null;
  config: any = {
    dateInputFormat: ' YYYY-MM-DD',
    showWeekNumbers: false,
    weekStart: 1,
  };

  test = new Date();
  private onChange: (value: string | null) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  @Input() defaultDate: Date;
  @Input() daysDisabled: number[] = [];
  @Input() maxDate: Date;
  @Input() minDate: Date;
  @Input() readonlyInput: boolean;
  @Output() selectedDateOutput = new EventEmitter<string>();

  propagateChange = (k: unknown): void => void 0;
  propagateTouched = (k: unknown): void => void 0;

  constructor(
    private injector: Injector,
    private changeDetector: ChangeDetectorRef,
  ) {}
  ngOnInit() {
    this.startDate = this.defaultDate;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['defaultDate']?.currentValue) {
      this.startDate = new Date(changes['defaultDate'].currentValue);
    }

    if (changes['maxDate']?.currentValue) {
      this.config.maxDate = changes['maxDate'].currentValue;
    }
  }

  ngAfterViewInit(): void {
    const ngControl = this.injector.get(NgControl, null);
    if (ngControl != null) {
      this.ngControl = ngControl;
    }

    this.changeDetector.detectChanges();
  }

  // ControlValueAccessor Implementation
  writeValue(value: Date | null): void {
    this.startDate = value;
  }

  registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  handleDateChange(event: Date) {
    const formatedDate = this.startDate
      ? moment(this.startDate).format('YYYY-MM-DD')
      : '';
    this.onChange(formatedDate);
    this.onTouched();
    this.selectedDateOutput.emit(formatedDate);
  }
}
